import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

@Component({
    selector: 'app-mandatory-comments-popup',
    templateUrl: './mandatory-comments-popup.component.html',
    styleUrls: ['./mandatory-comments-popup.component.scss'],
    standalone: false
})
export class MandatoryCommentsPopupComponent implements OnInit {

  commentsForm: FormGroup;
  buttonColor = '';
  commentText: string = ''; // bind this to input/textarea
  reviewerName: any;
  reviewedDate: any;
  comment: any; // for 'approve' action

  constructor(private fb: FormBuilder,private dialogRef: MatDialogRef<MandatoryCommentsPopupComponent>,private localStorageSettings: LocalStorageSettingsService,private jsignalService : JsignalService,
     private snackBar: MatSnackBar,private spinner: NgxUiLoaderService,
    @Inject(MAT_DIALOG_DATA) public data: { pssID: string, strategyID: string, action: 'complete' | 'approve' }
  ) {
    this.commentsForm = this.fb.group({
      comments: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.buttonColor = this.localStorageSettings.getSettings('ColorA');
    console.log(this.data.strategyID)
    this.getSectionComment("Review & Approval History",this.data.strategyID);
  }

  submit() {
    this.commentsForm.markAllAsTouched();
    if (this.commentsForm.valid) {
      this.dialogRef.close(this.commentsForm.value.comments);
    }
  }

  cancel() {
    this.dialogRef.close(null);
  }

  //get Section 
getSectionComment(title: string, id: string): void {
  this.spinner.start();
  this.jsignalService.getSection(title, id).subscribe({
    next: (res: any) => {
      if (!res || !Array.isArray(res.history) || res.history.length === 0) {
        console.error('No history  key found in response, skipping');
        this.spinner.stop();
        return;
      }

      const firstHistory = res.history[0];
        if (this.data.action === 'complete') {
          // Existing complete behavior
          this.reviewerName = firstHistory['Reviewer(s) Name'] || '';
          this.reviewedDate = firstHistory['Reviewed Date'] || '';

          let comment = firstHistory.Comment || '';
            // Remove leading "Reviewer:" if present
              if (comment.startsWith("Reviewer:")) {
                 comment = comment.replace(/^Reviewer:\s*(?:[\n\r\.\•\-\s]*)/i, "");
              }
          comment = comment.trim().replace(/\r\n|\r/g, '\n');
          this.commentsForm.get('comments')?.setValue(comment);

        } else if (this.data.action === 'approve') {
              this.reviewerName = firstHistory['Reviewer(s) Name'] || '';
              this.reviewedDate = firstHistory['Reviewed Date'] || '';

              let comment = firstHistory.Comment || '';
              comment = comment.trim();

              // break into lines every 100 characters
              this.comment = this.breakIntoLines(comment,100)
              
        }
        this.spinner.stop();
    },
    error: (err) => {
      console.error('Failed to fetch section:', err);
      this.spinner.stop();
    }
  });
}

 breakIntoLines(comment: string, limit: number = 100): string {
  const words = comment.split(' ');
  let line = '';
  let brokenComment = '';

  for (const word of words) {
    if ((line + word).length > limit) {
      brokenComment += line.trim() + '\n';
      line = '';
    }
    line += word + ' ';
  }

  if (line.length > 0) {
    brokenComment += line.trim();
  }

  return brokenComment;
}


}
